export default __webpack_public_path__ + "static/media/0073.52f6bad9.jpg";